import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

import '../styles/button.css';

class Button extends Component {
  render() {
    const { t } = this.context;

    const { name, label, customClass, type, translationVariables, onClick, disabled, icon } = this.props;

    return (
      <button name={name} className={`affiliate-btn ${customClass ? customClass : ''} ${disabled ? 'button-disabled' : ''}`} type={type || 'button'} onClick={onClick || ''} disabled={disabled}>
        <RenderIf if={icon}>
          <span className={`glyphicon ${icon} m-r-5`} />
        </RenderIf>
        <span>{t(label, translationVariables || {})}</span>
        <RenderIf if={disabled}>
          <span className="glyphicon glyphicon-repeat fast-right-spinner m-l-5" />
        </RenderIf>
      </button>
    );
  }
}

Button.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Button;



// WEBPACK FOOTER //
// ./src/app/shared/button/components/button.js